import { getEnforcedDomainValue } from "@/utils/admin-domain-filter"
import type { DomainEntity } from "@/types/domain"

/**
 * Media domain semantics:
 * - Selected "All domains" (id=0) → undefined (no domain param sent)
 * - Selected concrete site → domain string
 */
export function resolveMediaDomainParam(selectedDomain?: DomainEntity): string | undefined {
  const enforced = getEnforcedDomainValue(selectedDomain)
  return enforced ? enforced : undefined
}

